import { Link } from 'react-router-dom';
import { Box, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { StatusChip } from '../../ads_ingest_runs/components/StatusChip';
import { formatRows, formatDuration } from '../../../../../helpers/adsIngestRunsHelpers';
import { formatDateTime } from '../../../../../helpers/adsJobsHelpers';

export const JobLastRuns = ({ record }) => {
  const runs = Array.isArray(record.runs) ? record.runs : [];
  const total = record.runs_total ?? runs.length;

  return (
    <Paper variant="outlined" sx={{ borderRadius: 3, p: 3, mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 1 }}>
        <Typography variant="h6" fontWeight={600}>Last runs</Typography>
        <Typography color="text.secondary">{runs.length} of {total} shown</Typography>
      </Box>
      {runs.length ? (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Received</TableCell>
              <TableCell>Account</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Rows received / written</TableCell>
              <TableCell align="right">Duration</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {runs.map((run) => (
              <TableRow key={run.id}>
                <TableCell>
                  <Link to={`/ads_ingest_runs/${run.id}/show`}>{formatDateTime(run.received_at)}</Link>
                </TableCell>
                <TableCell>{run.account_name}</TableCell>
                <TableCell><StatusChip status={run.display_status} /></TableCell>
                <TableCell align="right">{formatRows(run)}</TableCell>
                <TableCell align="right">{formatDuration(run.duration_ms)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Typography color="text.secondary">No runs yet</Typography>
      )}
    </Paper>
  );
};
